import Axios from 'axios';

const baseURL = typeof window !== 'undefined' && window.location.hostname.includes('alphareview.in')
  ? `${window.location.origin}/api`
  : 'https://alphareview.in/api';

Axios.defaults.baseURL = baseURL;

export const axiosInstance = Axios.create({
  baseURL: baseURL,
});

export default Axios;